import { useEffect, useState } from 'react';

export function useDeferredPromoTile() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const finish = () => setReady(true);

    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(finish, { timeout: 2000 });
      return () => {
        if (typeof window.cancelIdleCallback === 'function') {
          window.cancelIdleCallback(idleId);
        }
      };
    }

    const timeoutId = window.setTimeout(finish, 1);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return ready;
}
